document.addEventListener("DOMContentLoaded", function () {
    const generateButton = document.getElementById("generate-ai-jersey");
    const colorInput = document.getElementById("color");
    const styleInstructionsInput = document.getElementById("style-instructions");
    const jerseyStyleSelect = document.getElementById("jersey-style");
    const previewImage = document.getElementById("ai-jersey-preview");
    const aiResultContainer = document.getElementById("ai-result");
    const downloadButton = document.getElementById("download-ai-jersey");

    // Social Share Buttons
    const shareFacebook = document.getElementById("share-facebook");
    const shareTwitter = document.getElementById("share-twitter");
    const copyLinkButton = document.getElementById("copy-link");

    if (!generateButton || !colorInput || !styleInstructionsInput || !jerseyStyleSelect || !previewImage || !downloadButton) {
        console.error("❌ One or more required elements are missing from the page.");
        return;
    }

    let isGenerating = false; // Prevent multiple requests

    // Remove existing event listeners to avoid duplicates
    generateButton.replaceWith(generateButton.cloneNode(true));
    const newGenerateButton = document.getElementById("generate-ai-jersey");

    newGenerateButton.addEventListener("click", async function () {
        if (isGenerating) {
            console.log("⚠️ A request is already in progress. Please wait.");
            return;
        }

        isGenerating = true; // Lock requests
        newGenerateButton.disabled = true; // Disable button to prevent multiple clicks
        newGenerateButton.textContent = "Generating... ⏳";

        const color = colorInput.value;
        const styleInstructions = styleInstructionsInput.value || "Modern and sleek";
        const jerseyStyle = jerseyStyleSelect.value;

        const userPrompt = `Design a high-quality, professional ${jerseyStyle} cycling jersey in the primary color ${color}. 
        The jersey should have a sleek, modern aesthetic with high-end fabric textures. 
        The design should include sponsor logo placements, aerodynamic patterns, and stylish accents. 
        Ensure the back and front design are visible with realistic lighting and depth. 
        ${styleInstructions}.`;

        console.log("📤 Sending request to DALL·E with prompt:", userPrompt);
        
        // Display loading message
        aiResultContainer.innerHTML = `<p>⏳ Generating your custom jersey... Please wait!</p>`;

        try {
            const response = await fetch("https://api.openai.com/v1/images/generations", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer `
                },
                body: JSON.stringify({
                    model: "dall-e-3",
                    prompt: userPrompt,
                    n: 1, // Force only one image to be generated
                    size: "1024x1024"
                })
            });

            const data = await response.json();

            if (data.data && data.data.length > 0) {
                const aiImageUrl = data.data[0].url;
                console.log("✅ AI Jersey Image Generated:", aiImageUrl);

                // Ensure the image element is visible and updated correctly
                previewImage.src = aiImageUrl;
                previewImage.style.display = "block";

                // Update AI result container
                aiResultContainer.innerHTML = `
                    <p>✅ Here is your AI-generated cycling jersey concept:</p>
                    <img id="ai-jersey-preview" src="${aiImageUrl}" alt="AI Jersey Preview" 
                        style="width: 100%; max-width: 400px; height: auto; border: 2px solid #00A86B;">
                    <br>
                    <a id="download-ai-jersey" href="${aiImageUrl}" download="custom_jersey.png">
                        <button>Download Jersey Design</button>
                    </a>
                    <br>
                    <button id="share-facebook" class="share-btn">Share on Facebook</button>
                    <button id="share-twitter" class="share-btn">Share on Twitter/X</button>
                    <button id="copy-link" class="share-btn">Copy Image Link</button>
                `;

                // Setup Share Links
                const shareText = encodeURIComponent("Check out my custom jersey designed with @Level_Velo! 🚴‍♂️ #LevelVeloCustom");
                document.getElementById("share-facebook").addEventListener("click", () => {
                    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(aiImageUrl)}`, "_blank");
                });

                document.getElementById("share-twitter").addEventListener("click", () => {
                    window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(aiImageUrl)}&text=${shareText}`, "_blank");
                });

                document.getElementById("copy-link").addEventListener("click", () => {
                    navigator.clipboard.writeText(aiImageUrl).then(() => {
                        alert("📋 Link copied to clipboard!");
                    });
                });

            } else {
                aiResultContainer.innerHTML = `<p>⚠️ Error: Unable to generate AI design.</p>`;
            }
        } catch (error) {
            console.error("❌ Error generating AI design:", error);
            aiResultContainer.innerHTML = `<p>⚠️ An error occurred while generating the design.</p>`;
        }

        isGenerating = false; // Unlock for next request
        newGenerateButton.disabled = false; // Re-enable button
        newGenerateButton.textContent = "Generate AI Design";
    });
});
